import { memo } from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

type PimSectionProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const PimSection = memo(({ value, onChange }: PimSectionProps) => (
  <FormControl variant="standard">
    <FormControlLabel
      control={
        <Checkbox
          id="pim-enabled"
          checked={Boolean(value)}
          onChange={event => onChange(event.target.checked)}
          color="primary"
        />
      }
      label="Enable PIM Access"
    />
    <FormHelperText>
      Recommended for production environments. (Applies only to Kubernetes
      access)
    </FormHelperText>
  </FormControl>
));
